import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const adminCompatibleApi = axios.create({
  baseURL: `${API_URL}/api/v1/admin`,
});

adminCompatibleApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json';
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

adminCompatibleApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminUser');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

const adminCompatibleService = {
  /**
   * Get all standalone products and collections for add-on association
   */
  getCompatibleItems: async () => {
    console.log('📤 [CompatibleService] Fetching compatible items...');
    try {
      const response = await adminCompatibleApi.get('/future-gifts/addons/compatible-items');
      console.log('📥 [CompatibleService] Compatible items fetched:', response.data);
      return response.data;
    } catch (error) {
      console.error('💥 [CompatibleService] Error fetching compatible items:', error);
      throw error;
    }
  },

  /**
   * Get standalone products
   */
  getStandaloneProducts: async () => {
    console.log('📤 [CompatibleService] Fetching standalone products...');
    try {
      const response = await adminCompatibleApi.get('/future-gifts/products/standalone');
      console.log('📥 [CompatibleService] Standalone products fetched:', response.data);
      return response.data;
    } catch (error) {
      console.error('💥 [CompatibleService] Error fetching standalone products:', error);
      throw error;
    }
  },

  /**
   * Get standalone collections
   */
  getStandaloneCollections: async () => {
    console.log('📤 [CompatibleService] Fetching standalone collections...');
    try {
      const response = await adminCompatibleApi.get('/future-gifts/collections/standalone');
      console.log('📥 [CompatibleService] Standalone collections fetched:', response.data);
      return response.data;
    } catch (error) {
      console.error('💥 [CompatibleService] Error fetching standalone collections:', error);
      throw error;
    }
  },

  /**
   * Associate add-on with product/collection
   */
  associateAddon: async (data) => {
    console.log('📤 [CompatibleService] Associating add-on:', data);
    try {
      const response = await adminCompatibleApi.post('/future-gifts/addons/associate', data);
      console.log('📥 [CompatibleService] Add-on associated:', response.data);
      return response.data;
    } catch (error) {
      console.error('💥 [CompatibleService] Error associating add-on:', error);
      throw error;
    }
  },

  /**
   * Remove add-on association
   */
  removeAssociation: async (data) => {
    console.log('📤 [CompatibleService] Removing add-on association:', data);
    try {
      const response = await adminCompatibleApi.post('/future-gifts/addons/remove-association', data);
      console.log('📥 [CompatibleService] Add-on association removed:', response.data);
      return response.data;
    } catch (error) {
      console.error('💥 [CompatibleService] Error removing add-on association:', error);
      throw error;
    }
  }
};

export default adminCompatibleService;